import Link from "@/components/link/Link";
import type { PortableTextTypeComponent } from "@portabletext/react";

// WIP: props will be updated as backend gets updated
// TBD: internal link may end up linking to nF or sportsbook

export interface LinkValue {
  _key: string;
  _type: string;
  addTag: boolean;
  link: Partial<LinkInfo>;
}

export interface LinkInfo {
  _ref: string;
  _type: string;
  externalLink: Partial<ExternalLink>;
}

export interface ExternalLink {
  _type: string;
  blank: boolean;
  href: string;
  label: string;
}

const LinkInternal: PortableTextTypeComponent = ({
  value,
}: {
  value: LinkValue;
}) => {
  const {
    link: { externalLink },
  } = value;

  const linkUrl = externalLink?.href;

  return linkUrl && externalLink?.label ? (
    <Link
      next={false}
      href={linkUrl}
      target={externalLink?.blank ? "_blank" : "_self"}
    >
      {externalLink.label}
    </Link>
  ) : (
    <span>{externalLink?.label}</span>
  );
};

export default LinkInternal;
